<script setup>
import { useChips } from '@/composables/chips'

import ChipTemplate from '@/components/shared/ChipTemplate.vue'

defineProps({
  warehouse: {
    type: Object,
    required: true,
  },
})

const { getVirtualLocationChip } = useChips()
</script>

<template>
  <span class="row inline items-center no-wrap">
    {{ warehouse.name }}
    <chip-template v-if="warehouse.is_virtual" :values="getVirtualLocationChip()" class="q-ml-sm" />
  </span>
</template>
